import React from 'react';
import styled from 'styled-components';

interface TitleInterface {
  title: string;
}

const PageTitle: React.FC<TitleInterface> = ({ title }) => {
  return <Title>{title}</Title>;
};

const Title = styled.h1`
  text-transform: uppercase;
  font-size: 2rem;
  font-family: ${({ theme }) => theme.fonts.stfMedium};
  font-weight: normal;
  color: ${({ theme }) => theme.colors.primary3};
  margin: 5rem 0;
`;

export default PageTitle;
